var QuadRowPackageData = require('./quadRowPackageData.js');
var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var PathData = require('../../../svg/pathData.js');
var PathObjectData = require('../../../svg/pathObjectData.js');
var PathType = require('../../../svg/pathType.js');
var IPCRules = require('../ipcRules');
var ComponentAttribute = require('./componentAttribute.js');

var PlccData = function(position, angle, init) {
    QuadRowPackageData.apply(this, arguments);

    this.terminalCenterToCenterDistance = this.value("terminalCenterToCenterDistance", true);
    this.terminalCenterToCenterDistance2 = this.value("terminalCenterToCenterDistance2", true);

    this.nonTransformedSegmentedGeometry.addTrigger(this.terminalCenterToCenterDistance);
    this.nonTransformedSegmentedGeometry.addTrigger(this.terminalCenterToCenterDistance2);

    if(init) this.padShape(ComponentAttribute.padShapes["Oblong"]);
};

lib_core.inherit(PlccData, QuadRowPackageData);
lib_core.JsonParser.registerClass(PlccData, "PlccData");

module.exports = PlccData;

PlccData.prototype.setupMinMaxPtrMap = function() {
    QuadRowPackageData.prototype.setupMinMaxPtrMap.call(this);
    this.validationMap["terminalCenterToCenterDistance"] = [this.terminalCenterToCenterDistance];
    this.validationMap["terminalCenterToCenterDistance2"] = [this.terminalCenterToCenterDistance2];
};

PlccData.prototype.getPads = function(absolutePositions) {
    var self = this;
    var pads = [];

    //reset component
    self.component.reset();

    //update for horizontal pads
    self.component.padWidthMax = self.horizontalLeadToLeadSpanMax() - self.terminalCenterToCenterDistance();
    self.component.padWidthMin = self.horizontalLeadToLeadSpanMin() - self.terminalCenterToCenterDistance();
    self.updateComponentCalculator(self.horizontalLeadToLeadSpanMin(), self.horizontalLeadToLeadSpanMax());

    //motif for horizontal pads
    var motif1 = self.getMotif();

    var i,
    	rowIdx,
        nRow1 = self.component.padsPerSide[0], //number of pads at left side
        nRow2 = self.component.padsPerSide[1], //number of pads at bottom side
        hPitch = self.component.C,
        pinPitch = self.verticalPinPitch(),
        hPadWidth = motif1.getTopCopper().width(),
        hPadHeight = motif1.getTopCopper().height(),
        hRx = motif1.getTopCopper().rx(),
        hRy = motif1.getTopCopper().ry();

    //update for vertical pads
    self.component.padWidthMax = self.verticalLeadToLeadSpanMax() - self.terminalCenterToCenterDistance2();
    self.component.padWidthMin = self.verticalLeadToLeadSpanMin() - self.terminalCenterToCenterDistance2();
    self.updateComponentCalculator(self.verticalLeadToLeadSpanMin(), self.verticalLeadToLeadSpanMax());

    //motif for vertical pads
    var motif2 = self.getMotif();

    var vPitch = self.component.C,
        vPadWidth = motif2.getTopCopper().width(),
        vPadHeight = motif2.getTopCopper().height(),
        vRx = motif2.getTopCopper().rx(),
        vRy = motif2.getTopCopper().ry();

    //left bottom half pads
    //if left side pad count is odd place middle pad at center else use an offset of (vertical pin pitch / 2) from center along +y direction
    for (i = 0; i < nRow1 / 2; i++) {
        var pad = motif1.clone();

        if(nRow1 % 2 == 0) {
        	pad.move(new lib_geometry.Coord(-0.5 * hPitch, -(i + 0.5) * pinPitch));
        } else {
        	pad.move(new lib_geometry.Coord(-0.5 * hPitch, -i * pinPitch));
        }

        pads.push(pad);
    }

    //bottom pads
    for (i = 0; i < nRow2; i++) {
        var pad = motif2.clone();
        pad.rotate(90);
        pad.move(new lib_geometry.Coord((-(nRow2 - 1) / 2 + i) * pinPitch, -0.5 * vPitch));
        pads.push(pad);
    }

	//right pads
    for (i = 0; i < nRow1; i++) {
        rowIdx = nRow1 - 1 - i % nRow1;

        var pad = motif1.clone();
        pad.padstack().topCopper().width(hPadWidth);
        pad.padstack().topCopper().height(hPadHeight);
        pad.padstack().topCopper().rx(hRx);
        pad.padstack().topCopper().ry(hRy);

        pad.move(new lib_geometry.Coord(0.5 * hPitch, ((nRow1 - 1) / 2 - rowIdx) * pinPitch));
        pads.push(pad);
    }

    //top pads
    for (i = 0; i < nRow2; i++) {
        rowIdx = nRow2 - 1 - i % nRow2;

        var pad = motif2.clone();
        pad.padstack().topCopper().width(vPadWidth);
        pad.padstack().topCopper().height(vPadHeight);
        pad.padstack().topCopper().rx(vRx);
        pad.padstack().topCopper().ry(vRy);

        pad.rotate(90);
        pad.move(new lib_geometry.Coord((-(nRow2 - 1) / 2 + rowIdx) * pinPitch, 0.5 * vPitch));
        pads.push(pad);
    }

    //left top half pads
    //if left side pad count is odd place middle pad at center else use an offset of (vertical pin pitch / 2) from center along -y direction
    var l = (self.component.padsPerSide[0] % 2 == 0 ? nRow1 / 2 : nRow1 / 2 - 1);
    for (i = 0; i < l; i++) {
        var pad = motif1.clone();

        if(nRow1 % 2 == 0) {
        	pad.move(new lib_geometry.Coord(-0.5 * hPitch, (Math.ceil(l) - i - 0.5) * pinPitch));
        } else {
        	pad.move(new lib_geometry.Coord(-0.5 * hPitch, (Math.ceil(l) - i) * pinPitch));
        }

        pads.push(pad);
    }

    self.updatePads(pads, absolutePositions);

    return pads;
};

PlccData.prototype.getSilkscreen = function(pads) {
    var silkscreen = [];

    //no silkscreen if there are no pads
    if(pads.length === 0) return silkscreen;

    //get body dimesnsions depending on mapping type of silkscreen to body
    var body = this.getBodyForSilkscreen();
    
    var leftMiddlePad = pads[0],
    	leftLastPadIdx = (this.component.padsPerSide[0] % 2 == 0 ? this.component.padsPerSide[0] / 2 - 1 : Math.floor(this.component.padsPerSide[0] / 2)),
        downFirstPad = pads[leftLastPadIdx + 1],
        leftFirstPad = (this.component.padsPerSide[0] == 1) ? leftMiddlePad : pads[leftLastPadIdx + 2 * this.component.padsPerSide[1] + this.component.padsPerSide[0] + 1];

    ////////////////////
    //   Pin Marker   //
    ////////////////////

    silkscreen.push(this.getPinOneMarker(leftMiddlePad, body, true));

    //////////////////////////////
    //   Component Silkscreen   //
    //////////////////////////////
    this.populateSilkscreenForBody(body, leftFirstPad, silkscreen, downFirstPad);

    return silkscreen;
};
